import type { TypedDocumentNode } from '@apollo/client';
import { graphql } from '@newfront-insurance/graphql-frontend';

type GenerateCitationFilePreviewUrlData = {
  generateFilePreviewUrl: {
    downloadUrl: string;
  };
};

type GenerateCitationFilePreviewUrlVariables = {
  input: {
    fileId: string;
  };
};

export const GENERATE_CITATION_FILE_PREVIEW_URL = graphql(`
  mutation GenerateCitationFilePreviewUrl($input: GenerateFilePreviewUrlInput!) {
    generateFilePreviewUrl(input: $input) {
      downloadUrl
    }
  }
`) as TypedDocumentNode<GenerateCitationFilePreviewUrlData, GenerateCitationFilePreviewUrlVariables>;
